import { render } from "./DashboardView.vue?vue&type=template&id=2e4116c6"
import script from "./DashboardView.vue?vue&type=script&lang=js"
export * from "./DashboardView.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src553776015/src/CheckAddressConsole/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__